import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";
import { addCommas } from "../../helpers/helpers";
import "./doughnut-chart.scss";
const DoughnutChart = (props) => {
  let percentage = props.percentages && [...props.percentages];
  let colors = props.colorPallete && [...props.colorPallete];

  percentage =
    percentage &&
    percentage.map((value) =>
      value == null || value === "" || isNaN(value) ? 0 : value,
    );

  let sum = percentage?.reduce((acc, val) => acc + parseFloat(val), 0);
  if (sum < 100) {
    percentage.push(100 - sum);
    colors.push("#fff");
  }
  const data = {
    datasets: [
      {
        data: percentage,
        backgroundColor: colors,
        borderWidth: 0,
        spacing: 1,
      },
      {
        data: percentage,
        borderColor: "#676767",
        borderWidth: 4,
        spacing: 0,
      },
    ],
  };

  const plugin = {
    id: "text",
    beforeDraw: function (chart) {
      var width = chart.width,
        height = chart.height,
        ctx = chart.ctx;
      ctx.restore();
      var fontSize = "18px";
      ctx.font = fontSize + " Calibri";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "#151f6d";
      var total_value_text = props.text,
        textX = Math.round(
          (width - ctx.measureText(total_value_text).width) / 2,
        ),
        textY = height / 2;
      ctx.fillText(total_value_text, textX, textY - 24);

      fontSize = "30px";
      ctx.font = fontSize + " Calibribold";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "#151f6d";
      var amount = "£" + addCommas(Math.trunc(props.totalValue)),
        textX1 = Math.round((width - ctx.measureText(amount).width) / 2),
        textY1 = height / 2;
      ctx.fillText(amount, textX1, textY1 + 10);
      ctx.save();
    },
  };

  const cutout = props.size === "small" ? ["30%", "100%"] : ["40%", "100%"];
  const radius = props.size === "small" ? ["40%", "26.5%"] : ["100%", "70%"];

  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;

    const ctx = canvas.getContext("2d");

    const chart = new Chart(ctx, {
      type: "doughnut",
      data: data,
      options: {
        responsive: false,
        maintainAspectRatio: false,
        cutout: cutout,
        radius: radius,
        hover: {
          mode: null,
        },
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false,
          },
        },
        onHover: "stuff",
      },
      plugins: props.showValue ? [plugin] : [],
    });

    return () => {
      chart.destroy();
    };
  }, [props.percentages]);

  return (
    <div className="doughnut-chart mt-5">
      <canvas ref={canvasRef} className="doughnut-pie"></canvas>
    </div>
  );
};

export default React.memo(DoughnutChart);
